import React from 'react';
import { getLocalCurrencyStr } from '@beef/utils';
import { connect } from 'react-redux';
import { Button, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { BALANCE_TYPES } from '@beef/elk-common/constants';
import { getIsTariffAccumsFttbDivideEnabled } from '@beef/elk-common/utils';
import { selectUserType } from "../../../../../../../store/selectors";
import { Metric } from "../../../../../../../utils/metric";
import { selectMainBalance, selectMainBalanceName, selectShowUnbilledCharges } from "../../../../store/selectors";
import styles from "./styles.pcss";
import { BalanceByDate } from "../BalanceByDate";
var cn = classNames.bind(styles);
export var _BalanceChoose = function _BalanceChoose(_ref) {
  var iconRight = _ref.iconRight,
    mainBalance = _ref.mainBalance,
    mainBalanceName = _ref.mainBalanceName,
    userType = _ref.userType,
    onClick = _ref.onClick,
    showUnbilledCharges = _ref.showUnbilledCharges;
  return /*#__PURE__*/React.createElement("div", {
    "data-component": "ubBalanceProfileBlock",
    "data-t-id": "components-BalanceChoose"
  }, /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      userType: userType,
      mainBalanceName: mainBalanceName
    }),
    events: {
      fubMetricSideMenu: ['handleAllBalancesClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('inline-btn'),
    iconRight: iconRight,
    mode: "inline",
    onClick: onClick,
    view: "secondary",
    "data-t-id": "components-BalanceChoose"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('balance-name', {
      extended: (mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.balanceType) === BALANCE_TYPES.CAC
    }),
    "data-t-id": "components-BalanceChoose"
  }, mainBalanceName))), /*#__PURE__*/React.createElement(Text, {
    color: mainBalance !== null && mainBalance !== void 0 && mainBalance.isBlocked ? 'error' : 'primary',
    size: "m"
  }, getLocalCurrencyStr((mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.balanceValue) || 0)), !!(mainBalance !== null && mainBalance !== void 0 && mainBalance.lastDate) && /*#__PURE__*/React.createElement(BalanceByDate, {
    lastDate: mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.lastDate
  }), showUnbilledCharges && /*#__PURE__*/React.createElement("div", {
    className: cn('date-block')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: "2xs"
  }, "\u0440\u0430\u0441\u0445\u043E\u0434\u044B \u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F ".concat(getLocalCurrencyStr(mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.unbilledCharges)))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    mainBalance: selectMainBalance(state),
    mainBalanceName: selectMainBalanceName(state),
    userType: selectUserType(state),
    showUnbilledCharges: selectShowUnbilledCharges(state) && getIsTariffAccumsFttbDivideEnabled()
  };
};
export var BalanceChoose = connect(mapStateToProps)(_BalanceChoose);